import React, { useState, memo } from 'react';
import { toast } from 'react-toastify';

import { Checkbox, Col, Row } from 'antd';

import MyModal from 'components/MyModal';
import type { IAffiliate } from 'v2/interfaces/affiliate';
import affiliateService from 'v2/services/affiliate';

interface IProps {
  closeModal: (...args: any[]) => any;
  active: boolean;
  affiliatesSelected: Array<IAffiliate>;
}

const ModalNewMessage = ({ closeModal, active, affiliatesSelected }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [sendEmail, setSendEmail] = useState(false);

  const handleClickNew = () => {
    if (!message) {
      toast.info('Escreva sua mensagem');
      return;
    }

    setLoading(true);

    const affiliates = affiliatesSelected.map(a => a.affiliate_id);

    affiliateService.sendMessageBroadcast(message, affiliates, sendEmail).subscribe(
      () => {
        toast.success('Mensagem enviada com sucesso');
        setLoading(false);
        setMessage('');
        setSendEmail(false);
        closeModal();
      },
      err => {
        toast.error(err);
        setLoading(false);
      }
    );
  };

  const handleChangeMessage = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
  };

  const handleChangeSendEmail = (e: any) => {
    setSendEmail(e.target.checked);
  };

  if (!active) {
    return null;
  }

  return (
    <MyModal
      hasActive
      title='Nova mensagem para afiliados'
      closeModal={closeModal}
      textButtonOk='Enviar'
      hasButtons
      handleClickOk={handleClickNew}
      loading={loading}
    >
      <div>
        <Row gutter={8}>
          <Col span={24}>
            <label>Texto da mensagem</label>
            <textarea
              className='text-text-secondary min-h-[60px] w-full resize-none rounded-sm border border-[#ced4da] p-[10px_12px] text-[15px] leading-[19px] font-normal transition-all duration-300 focus:border-[#a7a7a7]'
              onChange={handleChangeMessage}
              value={message}
            />
            <Checkbox checked={sendEmail} onChange={handleChangeSendEmail} style={{ padding: 0 }} />{' '}
            <span style={{ fontSize: 13 }}>Enviar cópia por e-mail</span>
          </Col>
        </Row>
      </div>
    </MyModal>
  );
};

export default memo(ModalNewMessage);
